// FormField.js
import React from 'react';
import { Input } from './input';
import { Textarea } from './textarea';
import clsx from 'clsx';

export const FormField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  inline = false, // New prop
  className,
  ...props
}) => {
  if (inline) {
    return (
      <div className={clsx('flex items-center mb-4', className)}>
        <label className="mr-2 font-medium">{label}</label>
        {type === 'textarea' ? (
          <Textarea name={name} value={value} onChange={onChange} {...props} />
        ) : (
          <Input type={type} name={name} value={value} onChange={onChange} {...props} />
        )}
      </div>
    );
  }

  return (
    <div className={clsx('mb-4', className)}>
      <label className="block mb-1 font-medium">{label}</label>
      {type === 'textarea' ? (
        <Textarea name={name} value={value} onChange={onChange} {...props} />
      ) : (
        <Input type={type} name={name} value={value} onChange={onChange} {...props} />
      )}
    </div>
  );
};
